var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfilepurple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55190",
    "data-name": "Group 55190",
    transform: "translate(-10 -13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "avatar_1_",
    "data-name": "avatar (1)",
    transform: "translate(-37.895 15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46473",
    "data-name": "Group 46473",
    transform: "translate(58.954 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46472",
    "data-name": "Group 46472",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8501",
    "data-name": "Ellipse 8501",
    cx: 6.941,
    cy: 6.941,
    r: 6.941
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46475",
    "data-name": "Group 46475",
    transform: "translate(53.895 15.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46474",
    "data-name": "Group 46474"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29480",
    "data-name": "Path 29480",
    d: "M65.895,256a12.126,12.126,0,0,0-12,12.249,3.234,3.234,0,0,0,3.2,3.266h17.6a3.234,3.234,0,0,0,3.2-3.266A12.126,12.126,0,0,0,65.895,256Z",
    transform: "translate(-53.895 -256)"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5515",
    "data-name": "Rectangle 5515",
    width: 36,
    height: 36,
    transform: "translate(10 13)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilepurple);
export default __webpack_public_path__ + "static/media/profilepurple.3f54ab16b4e3303df6cf52512a1c5156.svg";
export { ForwardRef as ReactComponent };